// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MGxE23ri6mjyEtY4pXTP {
  --header-height: 5rem;

  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
}

.wOeETs5XcPk67HDuEKwQ {
  flex: 1 1 auto;
  width: 100%;
  transition: opacity 0.5s ease;
}

.EoBPHqo0a58RiyTpthnK {
  opacity: 1;
}

.xDc6ZUBGeHQkeTMnbVgP {
  opacity: 0;
}

.UM3kaorQs2BvufYVlTGW {
  display: none;
}

.ytRrLT5gSvxnt8UqeVAi {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
}

.NsWIoUVB0bheXIxsEAoD {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  height: calc(100% - var(--footer-height));
  min-height: calc(100% - var(--footer-height));
}

.r7d6qeREddH_a9IpyvLw {
  display: flex;
  flex-direction: column;
  min-height: calc(100% - var(--header-height));
}

.f0NflABfgIYYGMKft1IB {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}

@media only screen and
  (min-width: 1280px) {
  .NsWIoUVB0bheXIxsEAoD {
    --footer-height: 5.5rem;
  }
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .NsWIoUVB0bheXIxsEAoD {
    --footer-height: 8.5rem;
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .NsWIoUVB0bheXIxsEAoD {
    --footer-height: 14.75rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .NsWIoUVB0bheXIxsEAoD {
    --footer-height: 14.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/Layout.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;;EAErB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EACE;IACE,uBAAqB;EACvB;AACF;;AAEA;;;EACE;IACE,uBAAsB;EACxB;AACF;;AAEA;;;EACE;IACE,yBAAsB;EACxB;AACF;;AAEA;;EACE;IACE,yBAAsB;EACxB;AACF","sourcesContent":[".layout {\n  --header-height: 80px;\n\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 100vh;\n}\n\n.content {\n  flex: 1 1 auto;\n  width: 100%;\n  transition: opacity 0.5s ease;\n}\n\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n.undisplayed {\n  display: none;\n}\n\n.fullScreen {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 100%;\n}\n\n.fullScreenInner {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  height: calc(100% - var(--footer-height));\n  min-height: calc(100% - var(--footer-height));\n}\n\n.bottomWrapper {\n  display: flex;\n  flex-direction: column;\n  min-height: calc(100% - var(--header-height));\n}\n\n.verticallyStretched {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n}\n\n@media (--desktop-large) {\n  .fullScreenInner {\n    --footer-height: 88px;\n  }\n}\n\n@media (--desktop-small) {\n  .fullScreenInner {\n    --footer-height: 136px;\n  }\n}\n\n@media (--tablet) {\n  .fullScreenInner {\n    --footer-height: 236px;\n  }\n}\n\n@media (--mobile) {\n  .fullScreenInner {\n    --footer-height: 236px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `MGxE23ri6mjyEtY4pXTP`,
	"content": `wOeETs5XcPk67HDuEKwQ`,
	"visible": `EoBPHqo0a58RiyTpthnK`,
	"invisible": `xDc6ZUBGeHQkeTMnbVgP`,
	"undisplayed": `UM3kaorQs2BvufYVlTGW`,
	"fullScreen": `ytRrLT5gSvxnt8UqeVAi`,
	"fullScreenInner": `NsWIoUVB0bheXIxsEAoD`,
	"bottomWrapper": `r7d6qeREddH_a9IpyvLw`,
	"verticallyStretched": `f0NflABfgIYYGMKft1IB`
};
export default ___CSS_LOADER_EXPORT___;
